// extracted by mini-css-extract-plugin
export default {"header":"Dashboard_header__j0J2g","header-title":"Dashboard_header-title__nSMHh","content":"Dashboard_content__7O-V9"};